import type { ExportState, MovementStatus } from '@/api/types'
import { EXPORT_LABELS, EXPORT_STYLES, STATUS_LABELS, STATUS_STYLES } from '@/utils/format'

export default function StatusBadge({ status }: { status: MovementStatus }) {
  return (
    <span className={`whitespace-nowrap rounded px-2 py-0.5 text-xs font-medium ${STATUS_STYLES[status]}`}>
      {STATUS_LABELS[status]}
    </span>
  )
}

/** Štítek exportu do Digitoo — jen když je co říct. */
export function ExportBadge({ state }: { state: ExportState }) {
  const label = EXPORT_LABELS[state]
  if (!label) return null
  return (
    <span className={`whitespace-nowrap rounded px-2 py-0.5 text-xs font-medium ${EXPORT_STYLES[state]}`}>{label}</span>
  )
}
